import { IFormValidation } from '@aston/foundation';

export class ICreateFederationValidator implements IFormValidation {
	ruleset = 'createFederationCommandValidator';
	fields = {
		Name: 'Name',
		WithCustomersAggregated: 'WithCustomersAggregated',
		CurrencyCode: 'CurrencyCode',
		SubsidiaryIds: 'SubsidiaryIds',
	};
}

export const CreateFederationValidator = new ICreateFederationValidator();
